import React from "react";

const formatTime = (value) => {
  if (!value) return "";

  return new Date(value).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
};

const MessageList = ({ messages, user }) => {
  return (
    <div className="message-list">
      {messages.map((msg, index) => {
        const isMine = msg.sender === user.username;

        return (
          <div
            key={msg._id || index}
            className={`message ${isMine ? "sent" : "received"}`}
          >
            <strong>{msg.sender}: </strong>
            {msg.message}
            <span className="message-meta">
              {formatTime(msg.createdAt)}
              {isMine && (
                <span className={`ticks ${msg.read ? "read" : ""}`}>
                  {msg.read ? "✓✓" : "✓"}
                </span>
              )}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default MessageList;
